import React from 'react';
import { Avatar as UserAvatar, Text, ThemeType } from '@gravity-ui/uikit';
import { headerT } from '../../../i18n/header.i18n';

type MascotProps = {
    theme: ThemeType;
};

export function Mascot({ theme: _theme }: MascotProps) {
    const url = './Mascot.png';
    const currentPageUrl = window.location.pathname;
    return (
        <a href={currentPageUrl} className="Header-mascot-link">
            <UserAvatar imgUrl={url} size="l" backgroundColor="unset" />
            <Text className="Header-logo" variant="display-1" color="primary">
                {headerT('appName')}
            </Text>
        </a>
    );
}
